import { Paragraph } from 'grommet';
import styled from 'styled-components';

const StyledParagraph = styled(Paragraph)`
  font-size: 18px;
  color: #444;
  margin-top: 16px;
`;

export default StyledParagraph;
